import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import StatusMessageBanner from "@components/StatusMessageBanner/StatusMessageBanner";
import { OperationalMessagesDisplay } from "@features/OperationalMessages/components";
const OperationalMessagesPage = () => {
    return (_jsxs(_Fragment, { children: [_jsx("div", { style: { marginTop: "1rem" }, children: _jsx(StatusMessageBanner, {}) }), _jsx(OperationalMessagesDisplay, {})] }));
};
export default OperationalMessagesPage;
